import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteMepvalues
export const DeleteMepvalues = createSlice({
  name: "DeleteMepvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteMepvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteMepvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteMepvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteMepvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteMepvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeleteMepvalues:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteMepvalues.reducer;
export const {
  DeleteMepvalues_datagrid,
  success_api_call_DeleteMepvalues_datagrid,
  failure_api_call_DeleteMepvalues_datagrid,
  create_DeleteMepvalues_datagrid_complete_api,
  DeleteMepvalues_datagrid_is_success,false_switchDeleteMepvalues
} = DeleteMepvalues.actions;
